export default {
  packageInformation: 'Package Information',
  printWaybill: 'Print Kilimall Waybill',
  waybillNumber: '国内运单号',
  logistics: 'Logistics Company',
  shoi: 'SHO Information',
  receiveri: 'Receiver Information',
  fromWarehouse: 'From Warehouse',
  deliver1: '已于',
  deliver2: '提交交付完成',
  area: '开始国内发货',
  delivery1: '请将包裹发送到指定中转仓',
  delivery2: '所在地',
  delivery3: '中转仓名称',
  delivery4: '联系人',
  delivery5: '联系电话',
  delivery6: '收货地址',
  tips1: '请先将订单点击为开始发货，然后待订单包裹准备好后再开始本地派送。',
  btn1: '开始发货',
  cancelOrder: 'Cancel the Confirmed Order',
  cancelStock: 'Cancel for No Stock',
  cancelOrder2: 'Cancel Order',
  addNumber: 'Add Global Logistic number',
  apply1: '订单交付完成申请',
  apply2: '订单已交付完成',
  startDelivery: 'Start Local Delivery',
  enterNumber: 'Please enter Local logistics package number',
  closeOrder: 'Close Order',
  radio1: 'Goods damaged',
  radio2: 'Goods is not same as in APP',
  radio3: 'Customer rejected with no reason',
  select1: 'Package Real Status',
  btn2: 'Customer rejected',
  btn3: 'Customer accepted the package',
  noLogisticsRecord: 'No logistics record.',
  cancelConfirmation: 'Cancel confirmation',
  tips1_order: 'Order will be cancelled, do you want to continue ',
  tips2: '请选择要使用的尾程快递公司',
  tips3: '(Please choose the delivery company)',
  tips4: '系统已经根据城市的配送情况做了默认配置，一般情况下无需更改，特殊情况下请手动指定快递服务商',
  radio4: 'eCourier',
  radio5: 'E-Desh (manually)',
  radio6: '自配送',
  btn4: '开始填写面单',
  tips5: 'The address cannot be found in the system.',
  modal1: 'E-Desh (manually)',
  modal2: 'E-Desh NO.',
  modal3: '备注',
  realStatus1: 'Shipped',
  realStatus2: 'In Delivery',
  realStatus3: 'Arrived',
  orderconditions1: '中通',
  orderconditions2: '圆通',
  orderconditions3: '申通',
  orderconditions4: '韵达',
  orderconditions5: '百世',
  orderconditions6: '人人',
  orderconditions7: '顺丰',
  orderconditions8: '京东',
  orderconditions9: '其他',
  rejectStatus1: 'Shipped',
  rejectStatus2: 'In Delivery',
  rejectStatus3: 'Arrived',
  storeIdMap1: 'TopSelective',
  storeIdMap2: 'FlyingGoods',
  storeIdMap3: 'Cost-effective',
  storeIdMap4: 'FashionMall',
  storeIdMap5: 'Digitone',
  storeIdMap6: 'FlashSK',
  paymentMethodMap1: 'Online',
  paymentMethodMap2: 'COD',
  paymentMethodMap3: 'pre',
  // ----
  packageStatusMap1: 'Pending Dispatch',
  packageStatusMap2: 'In Transit',
  packageStatusMap3: 'In Delivery',
  packageStatusMap4: 'Completed',
  packageStatusMap5: 'In Delivery',
  packageStatusMap6: 'Cancel',
  packageStatusMap7: 'Rejected',
  // -----
  shipOrderStatusMap1: 'Collecting Goods',
  shipOrderStatusMap2: 'Collection Completed',
  shipOrderStatusMap3: 'Packaged',
  shipOrderStatusMap4: 'In Transit',
  shipOrderStatusMap5: 'In Delivery',
  shipOrderStatusMap6: 'Completed',
  shipOrderStatusMap7: 'In Delivery',
  shipOrderStatusMap8: 'Rejected',
  shipOrderStatusMap9: 'Cancel',
  // ----
  delieveryIdMap1: '中通',
  delieveryIdMap2: '圆通',
  delieveryIdMap3: '申通',
  delieveryIdMap4: '韵达',
  delieveryIdMap5: '百世',
  delieveryIdMap6: '人人',
  delieveryIdMap7: '顺丰',
  delieveryIdMap8: '京东',
  delieveryIdMap9: '其他',
  // ------
  columnSHO1: 'SO#',
  columnSHO2: 'Ship Order',
  columnSHO3: 'Item',
  columnSHO4: 'Amount',
  columnSHO5: 'Status',
  columnSHO6: 'Seller Dispatch Time',
  columnSHO7: 'Package Complete Time',
  columnReceipt1: 'User ID',
  columnReceipt2: 'Country',
  columnReceipt3: 'State',
  columnReceipt4: 'City',
  columnReceipt5: 'Area',
  columnReceipt6: 'Address',
  columnReceipt7: 'Receiver',
  columnReceipt8: 'Contact Phone',
  tableColumnSku1: 'SKU#',
  tableColumnSku2: 'manufacture id',
  tableColumnSku3: 'Title',
  tableColumnSku4: 'Spec',
  tableColumnSku5: 'Price',
  tableColumnSku6: 'Discount',
  tableColumnSku7: 'Number',
  tableColumnSku8: 'Sub Total',
  tableColumnSku9: 'Weight',
  // -----
  columnShipPackage1: 'Package#',
  columnShipPackage2: 'Payment',
  columnShipPackage3: 'Early SHO Create',
  columnShipPackage4: 'User ID',
  columnShipPackage5: 'Due',
  columnShipPackage6: 'Online Pay',
  columnShipPackage7: 'Old Status',
  columnShipPackage8: 'Status',
  columnShipPackage9: 'Creat Time',
  columnShipPackage10: 'Print Time',
  columnShipPackage11: 'Delivery Time',
  columnShipPackage12: 'Close Time',
  columnShipPackage13: 'Logistics No.',
  // ---
  reason1: 'Damaged',
  reason2: 'Discrepancy',
  reason3: 'No reason',
  print: 'Print',
  columnSku1: 'SKU#',
  columnSku2: 'Title',
  columnSku3: 'Spec',
  columnSku4: 'Price',
  columnSku5: 'Number',
  columnSku6: 'Sub Total',
  columnSku7: 'Weight',
  sms1: '【2204】SMS turned off.',
  sms2: '【2252】SMS failed to send.',
  error1: '该商品从Dhaka退货仓发货，由Kilimall代处理',
  itemContent: 'Goods being delivered by@',
  deliverOrder1: '店铺自发货订单',
  deliverOrder2: '平台承运',
  warning1: '请先在店铺设置中配置好发货地址',
  warning2: '请选择快递',
  warning3: '请填写快递单号',
  confirmContent1: '请确认订单已自行或通过快递交付用户手中再执行此操作',
  warning4: 'Processing, please try again later.',
  error2: '备注信息不能超过20个字符',
  warning5: 'Please enter E_Desh Number.',
  warning6: 'Please enter correct Number.'
}
